import { Model } from 'peach/components'

const LoanRawLedger = ({ ledger }) => <Model.Item json={ledger} />

export default LoanRawLedger
